module.exports = __webpack_public_path__ + "static/img/12areaA_14.785ebaf.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/12areaA_14.png
// module id = 802
// module chunks = 1